import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { postChangePassword } from '@arrived/api_v2';
import { ApiError, UserId } from '@arrived/models';

export function usePostChangePasswordMutation(options?: UseMutationOptions<string, ApiError, UserId>) {
  return useMutation((userId) => postChangePassword(userId), {
    ...options,
  });
}
